import { render, staticRenderFns } from "./ChatHistoryPage.vue?vue&type=template&id=37e273d2&scoped=true"
import script from "./ChatHistoryPage.vue?vue&type=script&lang=js"
export * from "./ChatHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./ChatHistoryPage.vue?vue&type=style&index=0&id=37e273d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e273d2",
  null
  
)

export default component.exports